"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnviroment = exports.assembleURLWithOriginHashAndPin = exports.urlStringToUrlObject = void 0;
var urlStringToUrlObject = function (url) {
    var urlObj = new URL(url);
    return urlObj.origin;
};
exports.urlStringToUrlObject = urlStringToUrlObject;
var assembleURLWithOriginHashAndPin = function (baseURL, hash, pin) {
    return "".concat(baseURL, "?hash=").concat(hash).concat(pin ? "&pin=".concat(pin) : "");
};
exports.assembleURLWithOriginHashAndPin = assembleURLWithOriginHashAndPin;
var getEnviroment = function (path) {
    if (path.includes("localhost"))
        return "localhost";
    if (path.includes("integrations"))
        return "int";
    if (path.includes("qa"))
        return "qa";
    return "default";
};
exports.getEnviroment = getEnviroment;
